'use strict';

angular.module('cloudBillingLegacyFrontend').controller('AcCspCtrl', function ($scope, $eaCspService, $eaCurrentSession, $stateParams) {

  // the scope
  $scope.Profile = undefined;
  $scope.token = $eaCurrentSession.DataToken;
  $scope.tenantId = $stateParams.resellerId;
  
  // load the csp profile
  return $eaCspService.loadProfileById($stateParams.resellerId, $eaCurrentSession).then(function(cspProfile) {

    // set the profile
    $scope.Profile = cspProfile;
  })
});
